import React from 'react';
import API from '../../../api';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Dialog from 'material-ui/Dialog';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
// Needed for onTouchTap
import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();

export default class Profiles extends React.Component {
    constructor( props ) {
        super( props );
        this.state = {
            list: this.props.content,
            open: false,
            value: 10,
            title: null,
            description: null,
            errorTitle: null,
            errorDescription: null

        }
        this.handleClick = this.handleClick.bind();
        this.updateProfile = this.updateProfile.bind();
        this.addProfile = this.addProfile.bind();
        this.handleClose = this.handleClose.bind();
        this.handleChange = this.handleChange.bind();
        this.handleChangeSelect = this.handleChangeSelect.bind();
        this.handleSubmit = this.handleSubmit.bind();
    }

    componentWillReceiveProps(next){
        this.setState({list: next.content})
    }

    addProfile = () => {
        this.setState({ open: true });
    }

    handleSubmit = () => {

        if( this.state.title === null){
            this.setState({ errorTitle: "Required"})      
            return;
        }
        this.setState({ errorTitle: null});

        if( this.state.description === null){
            this.setState({ errorDescription: "Required" });
            return;
        }
        this.setState({ errorDescription: null });

        this.handleClose();
        let list = this.props.content;
        let text = this.state.description;
        let descriptionLines = text.split("\n");
        let newProfile = {
            name: this.state.title,
            quantity: 1,
            selected: true,
            description: descriptionLines
        }

        list.map( category => {
            if( category.min_range === this.state.value ){
                category.selected = true;
                category.profiles.push(newProfile);
            }
        });
        this.props.profiles( list );
    }

    handleClose = () => {
        this.setState({ open: false, 
            name: null, 
            description: null, 
            value: 10,
            errorTitle: null,
            errorDescription: null
        });
    }

    handleChange = (event) => {
        let field = event.target.name;
        this.setState({ [field]: event.target.value}, () => {
        })
    }

    handleChangeSelect = (event, index, value) => this.setState({value});

    handleClick = (e) => {
        let element = e.target;
        let name = element.dataset['profile'];

        if (!element.classList.contains('active')){
            // Add Class Active
            element.classList.add('active');
            this.updateProfile(name, true);
        }else{
            element.classList.remove('active');
            this.updateProfile(name, false);
        }
    }

    updateProfile = (name, isActive) => {
        let list = this.props.content;
        list.map((item, index) => {
            item.profiles.map( profile => {
                if (name == profile.name){
                    if(isActive == false){
                        profile.quantity = 1;
                    }
                    profile.selected = isActive;
                }
            })
        })
        this.props.profiles(list); 
    }

    render() {
        let content = null;
        let data = [];
        let title = `Technology Interested`;
        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={this.handleClose}
            />,
            <FlatButton
                label="Submit"
                primary={true}
                keyboardFocused={true}
                onClick={this.handleSubmit}
            />,
        ];


        const section = (item) => {
            return(
               <div><p>Range Budget: ${item.min_range} - ${item.max_range}</p>
                    { item.profiles.map( (data, index ) => {
                        let isActive = data.selected ? "active" : null
                        return <button className={isActive} 
                            onClick={this.handleClick} ref='profile' 
                            data-profile={data.name} 
                            key={`profile-${item.min_range}-${index}`}>{data.name}</button>
                        })
                    }<br /><br/>
                </div>        
            )
        }


        const template = () => {
            return(
                <div>
                    <h3 className="title-button">{ title }</h3>
                    
                    <RaisedButton label="Add Profile" primary={true} onClick={this.addProfile} />
                    { this.state.list.map( (item, index) => {
                        if ( item.selected )
                            return section(item);  
                    })}

                    <Dialog
                        title="New Profile"
                        className="dialog"
                        modal={false}
                        actions={actions}
                        open={this.state.open}
                        onRequestClose={this.handleClose} >
                        Please send fill the blanks to get a full description of your team’s profile.
                        <SelectField
                            floatingLabelText="Select you Hourly Rate Budget"
                            value={this.state.value}
                            onChange={this.handleChangeSelect}
                            name="rate">
                            <MenuItem value={10} primaryText="$10 - $15" />
                            <MenuItem value={15} primaryText="$15 - $20" />
                            <MenuItem value={20} primaryText="$20 - $25" />
                            <MenuItem value={25} primaryText="$25 - $30" />
                            <MenuItem value={35} primaryText="$35 - $40" />
                            <MenuItem value={40} primaryText="$40 - $60" />
                        </SelectField><br />

                        <TextField
                            hintText="Hint Text"
                            name="title"
                            onChange={this.handleChange}
                            errorText={this.state.errorTitle}
                            floatingLabelText="Technology Interested Tittle"
                        /><br />

                    <TextField
                        hintText="Message Field"
                        name="description"
                        floatingLabelText="MultiLine Description"
                        multiLine={true}
                        rows={2}
                        errorText={this.state.errorDescription}
                        onChange={this.handleChange}
                    /><br />

            </Dialog>
        </div>
            )
        }

        // Validate
        data = this.state.list.filter(e => e.selected == true);
        if(data.length > 0){
            content = template();
        }

        return (
            <section>
                {content}
            </section>            
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/build-your-team/views/selectProfiles.js